<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SelectContacts" });
import { SelectMultiple } from "../../../../selects/index.js";
import { ContactList } from "../../index.js";
export let keys = [];
export let parameters = {};
const format = (contacts) => contacts.filter((contact) => contact.name !== void 0).map(({ _, name }) => ({
    key: _.key,
    label: `${name}${_.state === "deleted" ? " (deleted)" : ""}`
}));
const getOptions = (contacts) => format(contacts);
</script>

<ContactList { parameters } let:contacts>

    <SelectMultiple
        bind:keys
        name = 'organization.contacts'
        label = 'Exisiting Contacts'
        placeholder = 'Select from existing buyer contacts'
        options = { getOptions(contacts) }
        showSortedList
    />

</ContactList>